import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class HealthWalletService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getTimeline(patientId, params = {}) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/health-wallet/timeline", { patientId }), {
            ...(await authenticatedApiConfig(this.authenticationProvider, params)),
            paramsSerializer: { indexes: null },
        });
        return response.data;
    }
    async dismissGap(patientId, body) {
        await axios.post(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/health-wallet/gaps/dismiss", { patientId }), body, await authenticatedApiConfig(this.authenticationProvider));
    }
    async getDetails(patientId, recordType, resourceId, unitSystem) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/health-wallet/:recordType/:resourceId", {
            patientId,
            recordType,
            resourceId,
        }), await authenticatedApiConfig(this.authenticationProvider, unitSystem ? { unitSystem } : undefined));
        return response.data;
    }
    async getVaccinationInsight(patientId, resourceId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/health-wallet/vaccination-insights/:resourceId", {
            patientId,
            resourceId,
        }), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getMeasurementInsight(patientId, observationId, unitSystem) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/health-wallet/measurement-insights/:observationId", {
            patientId,
            observationId,
        }), await authenticatedApiConfig(this.authenticationProvider, unitSystem ? { unitSystem } : undefined));
        return response.data;
    }
    async downloadDocument(patientId, documentId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/health-wallet/documents/:documentId/download", {
            patientId,
            documentId,
        }), {
            ...(await authenticatedApiConfig(this.authenticationProvider)),
            responseType: "blob",
        });
        return response.data;
    }
}
